import React from "react";
const AddFavourite = (props)=>{
    return (
        <>
        <span className='mr-2'>Add to Favourites❤️</span>
        </>
    );
}
export default AddFavourite;